import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb1e346a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PreTripDetailsTtn" }
const _hoisted_2 = { class: "PreTripDetailsTtn__content" }
const _hoisted_3 = { class: "content__direction-link" }
const _hoisted_4 = {
  key: 1,
  class: "content__direction"
}
const _hoisted_5 = { class: "content__container" }
const _hoisted_6 = { class: "container__param" }
const _hoisted_7 = { class: "container__param" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_9 = { class: "container__param" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.ttn.id)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: `/tms/ttns/${_ctx.ttn.id}`,
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.ttn.fromCity.name) + " - " + _toDisplayString(_ctx.ttn.toCity.name), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.ttn.fromCity.name) + " - " + _toDisplayString(_ctx.ttn.toCity.name), 1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, "Физ. вес: " + _toDisplayString(_ctx.ttn.totalWeight) + " кг", 1),
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode("Объём: " + _toDisplayString(_ctx.ttn.totalCubature) + " м", 1),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, "Номер ТТН: " + _toDisplayString(_ctx.ttn.number), 1)
      ])
    ])
  ]))
}